/**
 * Styled Components - Created by eduardoquintero on 19/09/19.
 */
import styled from 'styled-components'
import { GRAY_DARK } from '../../../theme/colors'

interface DivProps {
  selected?: boolean
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const Text = styled.div`
  color: ${GRAY_DARK};
  font-size: 10px;
  line-height: 19px;
  margin-top: 4px;
  text-align: center;
`
export const Icon = styled.img`
  max-height: 24px;
  height: 100%;
  object-fit: contain;
  ${({ selected }: DivProps) => selected ? `
    filter: drop-shadow(0px 0px 1px lightgrey);
  ` : ''}
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/DIYPrintApproval/Tab/styledComponents.tsx